<template>
  <div>
    <vhero>
      <template #title>Nuevo dispositivo</template>
      <template #subtitle>Añadir nuevo dispositivo a tu cuenta</template>
    </vhero>
    <div class="card_container" v-if="!activo">
      <Tarjeta class="tarjeta"></Tarjeta>
    </div>
    <div class="card_container" v-else>
      <b-button type="is-primary" @click.native="subscribe()">Activar notificaciones!</b-button>
    </div>
    <b-loading :is-full-page="false" :active="!esCargado"></b-loading>
  </div>
</template>

<script>
import Tarjeta from "../components/nuevoDispositivo/Tarjeta.vue";
import vhero from "@/components/shared/VHero.vue";
import { getDeviceUuid } from "../services/deviceUuid.js";
import { mapState } from "vuex";

export default {
  components: {
    vhero,
    Tarjeta
  },
  created() {
    const idDispositivo = getDeviceUuid();
    this.axios
      .get(`/Dispositivo/existe/${idDispositivo}`, {
        headers: {
          Authorization: `Bearer ${this.jwt}`
        }
      })
      .then(() => {
          this.activo = true
          this.esCargado = true
        })
      .catch(() => {
          this.activo = false
          this.esCargado = true
        });
  },
  data() {
    return {
      activo: false,
      esCargado: false
    };
  },
  computed: {
    ...mapState(["jwt"])
  },
  methods: {
    async subscribe() {
      const estadoNotificacion = Notification.permission;

      if(estadoNotificacion == "denied"){
        this.$toast.open({
          message: "Debes activar las notificaciones del navegador antes de continuar",
          type: "is-danger",
          position: "is-bottom"
        });
      }else{
        let sw = await navigator.serviceWorker.ready;
        
        let push;

        try {
          push = await sw.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey:
              "BKBpuS-S6nS9q1CqW4Eriq4YZLrNwzlgXOQiDMk-I6UV1qbd4UNXnynvGtDLRPpx53ZVLE6NWQ6pWp-VS4mmRJ0"
          });
        } catch (e) {
          this.$toast.open({
            message: "No compatible o notificaciones desactivadas",
            type: "is-danger",
            position: "is-bottom"
          });
        }
  
        let pushData = push.toJSON();
  
        const data = {
          Identificacion: getDeviceUuid(),
          PushEndpoint: pushData.endpoint,
          // @ts-ignore: Object is possibly 'undefined'
          PushP256DH: pushData.keys.p256dh,
          // @ts-ignore: Object is possibly 'undefined'.
          PushAuth: pushData.keys.auth
        };
  
        this.axios
          .post("/WebPush/SavePushDevice", data, {
            headers: {
              Authorization: `Bearer ${this.$store.state.jwt}`
            }
          })
          .then(() => {
            this.$toast.open({
              message: "Se ha subscrito a las notificaciones correctamente!",
              type: "is-success",
              position: "is-bottom"
            });
          })
          .catch(() => {
            this.$toast.open({
              message: "Error del servidor al subscribir a las notificaciones",
              type: "is-danger",
              position: "is-bottom"
            });
          });
      }

    }
  }
};
</script>

<style scoped>
.card_container {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tarjeta {
  width: 90%;
}
.card_container {
  margin-top: 40px;
}
@media (min-width: 768px) {
  .tarjeta {
    width: 60%;
  }
}
</style>